import { TooltipProps } from '@mui/material/Tooltip';

import Tooltip from './Tooltip';

export default Tooltip;
export type { TooltipProps };
